import { useState } from "react";
import { Upload, Loader2, Paperclip } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export function FileUpload({ accept, label = "Upload file", fileName, onUploaded, testId = "file-upload" }) {
  const [pct, setPct] = useState(null);
  const [error, setError] = useState(null);

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setError(null);
    setPct(0);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/files", form, { onUploadProgress: (ev) => setPct(Math.round((ev.loaded / (ev.total || 1)) * 100)) });
      onUploaded(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setPct(null);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <label className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-dashed border-lasso-line bg-white px-4 py-2 text-xs font-semibold transition-colors hover:border-lasso-ink">
        {pct !== null ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}
        {pct !== null ? `Uploading ${pct}%` : label}
        <input type="file" accept={accept} className="hidden" onChange={onChange} disabled={pct !== null} data-testid={testId} />
      </label>
      {fileName && <p className="flex items-center gap-1.5 text-xs text-zinc-600" data-testid={`${testId}-name`}><Paperclip className="h-3 w-3" />{fileName}</p>}
      {error && <p className="text-xs text-rose-600">{error}</p>}
    </div>
  );
}
